import { render, staticRenderFns } from "./distribution-page.vue?vue&type=template&id=38d22b70"
import script from "./distribution-page.vue?vue&type=script&lang=js"
export * from "./distribution-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports